import { createFileRoute } from '@tanstack/react-router';

import { UsagePage, spendSearchSchema } from '@/features/workspace-usage';

export const Route = createFileRoute('/workspaces/$workspaceId/ai-usage/spend')(
  {
    // The period lives in the address (spec 072 FR-005), so a view can be linked and
    // restored.
    validateSearch: spendSearchSchema,
    component: UsageRoute,
  },
);

export function UsageRoute() {
  const { workspaceId } = Route.useParams();
  const { period, view, split } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <UsagePage
      workspaceId={workspaceId}
      period={period}
      view={view ?? 'cumulative'}
      split={split ?? 'workflow'}
      onPeriodChange={(next) => {
        // `replace` so stepping through months does not fill the back button with a
        // month-by-month trail the reader has to unwind to leave the page.
        void navigate({
          search: (prev) => ({ ...prev, period: next }),
          replace: true,
        });
      }}
      onViewChange={(next) => {
        void navigate({
          search: (prev) => ({
            ...prev,
            view: next === 'per-day' ? 'per-day' : undefined,
          }),
          replace: true,
        });
      }}
      onSplitChange={(next) => {
        void navigate({
          search: (prev) => ({
            ...prev,
            split: next === 'workflow' ? undefined : next,
          }),
          replace: true,
        });
      }}
    />
  );
}
